
import Vue from 'vue'
import FastClick from 'fastclick';

import MainView from './MainView'
import config from './data/config'

// Assume jQuery is global
$(()=>{

  //console.log('PAINT v' + config.VERSION, 'ENV=' + config.ENV);

  // Start Main View when doc is loaded
  new Vue({
    el: 'body',
    components: {MainView}
  });

  // faster clicks on mobile
  FastClick.attach(document.body);

  // disable ios touch drag scroll
  $('body').on('touchmove', false);

  // $(function() {
  //   function orientationChange(e) {
  //     $("body").css({ height: $(window).height()+1 }).scrollTop(1);
  //   }
  //   orientationChange();
  //   $(window).bind("orientationchange", orientationChange);
  // });

});



// WEBPACK FOOTER //
// ./src/main.js